// Copyright (c) 2026 by Audere

import { Navigate, Outlet, useLocation } from "react-router-dom";

import { selectCurrentToken } from "../features/auth/authSlice";
import { useSelector } from "react-redux";

const RequireAuth = () => {
  const isLoggedIn = !!useSelector(selectCurrentToken);
  const location = useLocation();
  return isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireAuth;
